var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"type":"line","height":"100%","width":"100%","options":_vm.options,"series":_vm.series},on:{"click":_vm.chartClickEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }